import { CATEGORY_KEYS as K } from './categoryKeys';

/**
 * Single source of truth for business types and allowed category keys.
 * UI labels live here; allowedCategories drive getCategoriesForBusinessType.
 */
export const businessTypes = {
  boucherie: {
    name: 'Boucherie',
    nameAr: 'جزارة',
    description: 'Viande & Aliments Frais',
    descriptionAr: 'اللحوم والأطعمة الطازجة',
    allowedCategories: [K.ALIMENTS_BOISSONS],
  },
  supermarche: {
    name: 'Supermarché',
    nameAr: 'سوبر ماركت',
    description: 'Supermarché de Détail Complet',
    descriptionAr: 'سوبر ماركت تجزئة شامل',
    allowedCategories: [
      K.ALIMENTS_BOISSONS,
      K.BOULANGERIE_PATISSERIE,
      K.PRODUITS_TRADITIONNELS_MAURITANIENS,
      K.SANTE_BEAUTE,
      K.ARTICLES_MENAGERS,
      K.ELECTRONIQUE,
      K.VETEMENTS_HABILLEMENT,
      K.BEBE_ENFANT,
      K.ANIMAUX_COMPAGNIE,
      K.LIVRES_MEDIA,
      K.MAISON_JARDIN,
      K.PRODUITS_LAITIERS_SPECIALISES,
      K.EPICERIE_FINE,
      K.BOISSONS_ALCOOLISEES,
      K.PRODUITS_HALAL,
      K.PRODUITS_BIO,
      K.PRODUITS_VEGETARIENS,
      K.PRODUITS_VEGANS,
      K.PRODUITS_SANS_GLUTEN,
    ],
  },
  restaurant: {
    name: 'Restaurant',
    nameAr: 'مطعم',
    description: 'Service Alimentaire & Opérations de Cuisine',
    descriptionAr: 'خدمة الطعام وعمليات المطبخ',
    allowedCategories: [
      K.MENU_RESTAURANT,
      K.ALIMENTS_BOISSONS,
      K.BOULANGERIE_PATISSERIE,
    ],
  },
  epicerie: {
    name: 'Épicerie',
    nameAr: 'بقالة',
    description: 'Épicerie & Articles Quotidiens',
    descriptionAr: 'بقالة ومستلزمات يومية',
    allowedCategories: [
      K.ALIMENTS_BOISSONS,
      K.SANTE_BEAUTE,
      K.ARTICLES_MENAGERS,
      K.BEBE_ENFANT,
      K.PRODUITS_HALAL,
      K.PRODUITS_BIO,
      K.PRODUITS_SANS_GLUTEN,
    ],
  },
  pharmacie: {
    name: 'Pharmacie',
    nameAr: 'صيدلية',
    description: 'Pharmacie & Produits Médicaux',
    descriptionAr: 'صيدلية ومنتجات طبية',
    allowedCategories: [
      K.SANTE_BEAUTE,
      K.PHARMACIE,
      K.MATERIEL_MEDICAL,
      K.SOINS_PERSONNELS,
      K.PRODUITS_COSMETIQUES,
    ],
  },
  magasin: {
    name: 'Magasin',
    nameAr: 'متجر',
    description: 'Magasin de Détail Général',
    descriptionAr: 'متجر تجزئة عام',
    allowedCategories: [
      K.ALIMENTS_BOISSONS,
      K.ELECTRONIQUE,
      K.VETEMENTS_HABILLEMENT,
      K.SANTE_BEAUTE,
      K.ARTICLES_MENAGERS,
      K.MAISON_JARDIN,
      K.BUREAU_SCOLAIRE,
      K.SPORT_PLEIN_AIR,
      K.JOUETS_JEUX,
      K.BIJOUX_MONTRES,
      K.BEBE_ENFANT,
      K.ANIMAUX_COMPAGNIE,
      K.TEXTILE_TISSUS,
    ],
  },
  electronique: {
    name: "Magasin d'Électronique",
    nameAr: 'متجر إلكترونيات',
    description: 'Électronique, Accessoires & Gadgets',
    descriptionAr: 'إلكترونيات وإكسسوارات وأدوات',
    allowedCategories: [K.ELECTRONIQUE],
  },
  bricolage: {
    name: 'Bricolage & Matériaux',
    nameAr: 'أدوات ومواد البناء',
    description: 'Éclairage, portes, sanitaire, quincaillerie & matériaux',
    descriptionAr: 'إضاءة وأبواب وصحي وعدد ومواد بناء',
    allowedCategories: [
      K.CONSTRUCTION_BRICOLAGE,
      K.QUINCAILLERIE,
      K.MAISON_JARDIN,
      K.ARTICLES_MENAGERS,
      K.FLEURS_PLANTES,
    ],
  },
  'mauritanian-market': {
    name: 'Marché Mauritanien',
    nameAr: 'السوق الموريتاني',
    description: 'Marché Traditionnel Mauritanien',
    descriptionAr: 'السوق التقليدي الموريتاني',
    allowedCategories: [
      K.ALIMENTS_BOISSONS,
      K.PRODUITS_TRADITIONNELS_MAURITANIENS,
      K.BOULANGERIE_PATISSERIE,
      K.SANTE_BEAUTE,
    ],
  },
};

/**
 * Top-level tree keys intentionally not assigned to any business type yet.
 * Kept explicit so integrity tests fail on silent orphans.
 */
export const UNASSIGNED_CATEGORY_KEYS = [
  'office-school', // aliased → office-business-school; kept for legacy product rows
  'automotive',
  'restaurant-hotel',
  'music-instruments',
  'art-crafts',
  'vehicles-motorcycles',
];

/** @deprecated Use businessTypes — kept as alias for gradual migration. */
export const BUSINESS_TYPE_CONFIG = Object.fromEntries(
  Object.entries(businessTypes).map(([id, cfg]) => [
    id,
    { allowedCategories: cfg.allowedCategories },
  ])
);
